import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import animateProps from 'react-animate-props';
import { Easing } from 'tweenkle';

const { floor } = Math;

const ProgressBarElement = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: white;
  opacity: ${({ opacity }) => opacity};
  transition: all 0.3s ease-out;
  box-shadow: 0px 0px 10px, 0px 0px 20px;
`;

const ProgressBar = ({ opacity, stayVisible, width }) => (
  <ProgressBarElement
    style={{
      width,
      opacity: stayVisible ? 1.0 : opacity,
    }}
  />
);

ProgressBar.propTypes = {
  width: PropTypes.string.isRequired,
  stayVisible: PropTypes.bool,
  opacity: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
  animateProps: PropTypes.object,
};

ProgressBar.defaultProps = {
  stayVisible: false,
  opacity: 0.0,
  animateProps: {
    opacity: {
      ease: Easing.Quad.InOut,
      delay: 0,
      duration: 1000,
    },
  },
};

export default connect(
    ({ panorama, map, ui }) => {
      const progress = floor(ui.isMapUi ? map.progress : panorama.progress);

      return {
        opacity: progress === 100.0 ? 0.0 : 1.0,
        width: `${progress}%`,
      };
    },
)(animateProps(ProgressBar, ProgressBar.defaultProps));
